import React from "react";

export default function HeroSection() {
  return (
    <section id="home " className="bg-dark text-white text-center py-5">
      <div className="container">
        <h1 className="display-4 fw-bold">
          Hi, I'm <span className="text-info">Natalie</span>
        </h1>
        <p className="lead mt-3">Junior Front-End Developer</p>
        <a href="#projects" className="btn btn-info btn-lg mt-3">
          View My Work
        </a>
      </div>
    </section>
  );
}
